module.exports = __webpack_public_path__ + "static/media/close.cb0d89e5.svg";